// Angular
import { Component, OnInit, Input } from "@angular/core";
// Services
import { ElasticService } from "./../../services/elastic";
// External
import * as lodash from "lodash";
import { ApiService } from "./../../services/api";
import { ActivatedRoute } from "@angular/router";

@Component({
  templateUrl: "./users.component.html",
  selector: "app-users",
})
export class UsersComponent implements OnInit {
  public query: string;
  public isPro: number = 3;
  private typingDelay: any;
  public currentPage: number;
  public maxPage: number;
  public users: Array<any>;
  public imageLoader: boolean = true;
  public pageSize: number;
  constructor(
    private route: ActivatedRoute,
    private elasticService: ElasticService,
    private apiService: ApiService
  ) {
    this.currentPage = 0;
    this.pageSize = 20;
    this.query = "";
  }

  ngOnInit() {
    console.log("isPro: ",this.isPro, this.route.snapshot.params["isPro"])  
    if (this.route.snapshot.params["isPro"])
      this.isPro = this.route.snapshot.params["isPro"];

    this.goToPage(this.currentPage);
  }
  getQuery(fromIndex)
  {
    let queryParams={}
    if (this.query == undefined || this.query == "") {
        queryParams = {
          index: "users",
          type: "user",
          "body/sort/createdAt/order": `desc`,
          size: this.pageSize,
          from: fromIndex,
        };

      } else {
        queryParams = {
          index: "users",
          type: "user",
          size: this.pageSize,
          from: fromIndex,
          "body/query/bool/must/match_phrase_prefix/fullName": `*${this.query.trim().toLowerCase()}*`,
        };
    }
    return queryParams;
  }
  goToPage(index: number) {
    const fromIndex = index * this.pageSize;
    var queryParams = {};
    console.log((this.isPro == 1) ? true : false);
    if (this.isPro == 1 || this.isPro == 2) {
      queryParams = this.getQuery(fromIndex);
      // queryParams["body/query/match/isPro"] = (this.isPro == 1) ? true : false
      queryParams["body/query/bool/filter/term/isPro"] = (this.isPro == 1) ? true : false
    }
    else {
     queryParams = this.getQuery(fromIndex);
    }
    console.log("queryParams", queryParams)
    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.users = [];
        console.log(result);
        if (result) {
          this.apiService.set("currentVersion/testing", result);
          lodash.forEach(result["hits"], (item) => {
            // item['_source']['appversion'] = item['_source']['app-version']
            this.users.push(
              lodash.assign({ id: item["_id"] }, item["_source"])
            );
          });

          window.scrollTo(0, 0);
          this.imageLoader = false;
          this.currentPage = index;
          this.maxPage = Math.ceil(result["total"] / this.pageSize);
          console.log(this.maxPage, result["total"], this.pageSize, fromIndex);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }

  getIndex(index: number) {
    return this.currentPage * this.pageSize + index + 1;
  }
  formatTime(timestamp) {
    const date = new Date(timestamp * 1000);

    // const time1 = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }
  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.goToPage(0);
    }, 400);
  }

  activate(item) {
    if (confirm("Are you sure,you want to Activate the user?")) {
      this.apiService
        .set(`/users/${item.id}/deactivated`, false)
        .then(() => {
          item.deactivated = false;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  async deactivate(item) {
    if (confirm("Are you sure,you want to Deactivate the user?")) {
      this.apiService
        .set(`/users/${item.id}/deactivated`, true)
        .then(() => {
          item.deactivated = true;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  blockUser(item) {
    if (confirm("Are you sure,you want to Block the user?")) {
      this.apiService
        .set(`/users/${item.id}/isBlock`, true)
        .then(() => {
          item.isBlock = true;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  unBlockUser(item) {
    if (confirm("Are you sure,you want to unblock the user?")) {
      this.apiService
        .set(`/users/${item.id}/isBlock`, false)
        .then(() => {
          item.isBlock = false;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
